import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { File } from '@ionic-native/file';
import { saveAs } from 'file-saver';
import { NavController, Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import { History, Proband } from '../../../data/data';
import { DataProvider } from '../../../provider/data-service';
import { HelperProvider } from '../../../provider/helper-service';
import { RecordsProbandPage } from '../recordsSession/recordsProband';

@Component({
    selector: 'page-records',
    templateUrl: 'records.html'
})
export class RecordsPage {

    public history: History;

    constructor(
        public navCtrl: NavController,
        private platform: Platform,
        private file: File,
        private dataProvider: DataProvider,
        private helper: HelperProvider,
        private datePipe: DatePipe

    ) {
        // Hier Daten neu aus Storage laden. (sicher ist sicher)
        this.dataProvider.load().subscribe(history => {
            this.history = this.dataProvider.history;
        });
    }

    public open(proband: Proband): void {
        this.navCtrl.push(RecordsProbandPage, { proband: proband });
    }

    public export(): void {
        const json = JSON.stringify(this.history);
        let fileName = `mpt_export_${this.datePipe.transform(new Date(), 'yyyy-MM-dd_hhmmss')}.json`;

        if (this.platform.is('core')) {
            // im Browser (Platform browser und ionic serve) herunterladen
            const blob = new Blob([json], {
                type: 'text/json'
            });
            saveAs(blob, fileName);

        } else {
            // am mobilen Gerät als Datei speichern
            let baseDir = '';
            if (this.platform.is('core')) {
                // Platform Browser (but not serve)
                baseDir = 'cdvfile://localhost/temporary/';
            } else if (this.platform.is('ios')) {
                // iOS
                baseDir = this.file.documentsDirectory;
            } else {
                // Android etc.
                baseDir = this.file.externalRootDirectory;
            }

            let destDir;
            let createDir;
            if (this.platform.is('ios')) {
                // In iOS in das Documents-Verzeichnis speichern. Das Documents Directory ist nur für
                // diese App sichtbar und muss via iTunes auf den PC übertragen werden.
                // Achtung: es muss UIFileSharingEnabled in ...-Info.plist enthalten sein, damit die Datei
                // in iTunes unter File-Sharing ersichtlich ist: https://stackoverflow.com/a/36798982/1018443
                destDir = baseDir;
                createDir = Observable.of(null);
            } else {
                const subDir = 'MPT';
                destDir = baseDir + subDir + '/';
                createDir = Observable.fromPromise(this.file.checkDir(baseDir, subDir)).catch(err => {
                    return Observable.fromPromise(this.file.createDir(baseDir, subDir, false));
                });
            }

            const writeFile = createDir.flatMap(direntry => {
                return Observable.fromPromise(this.file.listDir(destDir, ''));
            }).flatMap(entries => {
                console.log(`Vorhandene Files in ${destDir}:`)
                console.log(entries);
                return Observable.fromPromise(this.file.writeFile(destDir, fileName, json, { replace: false }));
            });

            this.helper.wrapErrorHandler(writeFile).subscribe(ret => {
                console.log(`File ${destDir}${fileName} saved!`);
                if (this.platform.is('ios')) {
                    this.helper.alertMessage('Export', `Datei wurde gespeichert: Documents/${fileName}. Die Datei kann in iTunes via File-Sharing übertragen werden.`).subscribe();
                } else {
                    this.helper.alertMessage('Export', `Datei wurde gespeichert: ${destDir}${fileName}`).subscribe();
                }
            });
        }
    }

    public deleteAll(): void {
        this.helper.alertConfirm('Frage', 'Alle Daten werden gelöscht. Sind Sie sicher?').subscribe(result => {
            if (result) {
                this.helper.alertConfirm('Frage', 'Sind Sie wirklich sicher?').subscribe(result2 => {
                    if (result2) {
                        this.dataProvider.clear();
                    }
                });
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/records/records/records.ts